export const AUTHORIZE_USER = 'AUTHORIZE_USER';
export const CREATE_USER_IF_NOT_EXIST = 'CREATE_USER_IF_NOT_EXIST';



// WEBPACK FOOTER //
// ./src/store/modules/oauth2/constants.js